import { useFrontendTable } from "components/table";
import { Table } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { LocationLink } from "utils/LinkUtils";
import { DataFormat } from "utils";
import CargoActionTypeTag from "view/cargos/components/tags/CargoActionTypeTag";
import { ExpectedCargoDetailsFragment as ExpectedCargo } from "__generated__/view/cargos/graphql/cargo.fragments.generated";

const ExpectedCargosTable = ({ expectedCargos }: { expectedCargos: ExpectedCargo[] }) => {

	const { tableProps } = useFrontendTable({
		id: "expected-cargos-call-details",
		content: expectedCargos,
		saveForOrganizationEnabled: false,
	});

	return (
		<Table
			{...tableProps}
			columns={[ {
				id: "actionType",
				title: intl.formatMessage({ id: "CARGO_ACTION_TYPE" }),
				render: (row: ExpectedCargo) => <CargoActionTypeTag type={row.actionType} />,
				sortable: true,
			}, {
				id: "containerType",
				title: intl.formatMessage({ id: "CARGO_CONTAINER_TYPE" }),
				render: (row: ExpectedCargo) => row.containerType.isoTypeCode,
				sortable: true,
			}, {
				id: "amount",
				title: intl.formatMessage({ id: "AMOUNT" }),
				sortable: true,
			}, {
				id: "dischargingLocation",
				title: intl.formatMessage({ id: "ORDER_DISCHARGING_PLACE" }),
				render: (row: ExpectedCargo) => <LocationLink location={row.dischargingLocation} />,
			}, {
				id: "full",
				title: intl.formatMessage({ id: "FULL" }),
				render: (row: ExpectedCargo) => DataFormat.boolean(row.full),
			}, {
				id: "reefer",
				title: intl.formatMessage({ id: "REEFER" }),
				render: (row: ExpectedCargo) => DataFormat.boolean(row.containerType.reefer),
			} ]}
		/>
	);
};

export default ExpectedCargosTable;
